<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <!-- keep-alive：路由 meta.keepAlive=true 的页面被缓存，返回时保持状态 -->
      <keep-alive>
        <router-view v-if="$route.meta && $route.meta.keepAlive" />
      </keep-alive>
    </transition>
    <transition name="fade" mode="out-in">
      <router-view v-if="!$route.meta || !$route.meta.keepAlive" :key="$route.fullPath" />
    </transition>

    <!-- 全局悬浮音乐播放器（跨路由保留，仅受 music/showFloatingPlayer 状态控制） -->
    <MusicFloatingPlayer />

    <!-- 全局设置面板（通过 $bus.$emit('open-settings') 触发显示） -->
    <SettingsPanel />
  </div>
</template>

<script>
import MusicFloatingPlayer from '@/components/kyu-player/MusicFloatingPlayer.vue'
import SettingsPanel from '@/components/common/SettingsPanel.vue'
import { initAudioManager } from '@/components/kyu-player/music/audioManager'

import { initTheme, loadUserThemeFromBackend } from '@/utils/theme'

export default {
  name: 'App',
  components: {
    MusicFloatingPlayer,
    SettingsPanel
  },
  created() {
    // 初始化应用主题（从 localStorage 恢复）
    initTheme()
    // 恢复全局壁纸设置（与 BackgroundSetting.vue 保持一致）
    this.initGlobalWallpaper()
    // 登录状态下，从后端加载用户主题/背景设置
    this.loadUserThemeSettings()
  },
  mounted() {
    // 初始化全局音频管理器（单例，确保在路由切换时持续播放）
    if (this.$store) {
      initAudioManager(this.$store)
    }
  },
  methods: {
    initGlobalWallpaper() {
      const wallpaperUrl = localStorage.getItem('wallpaperUrl')
      const wallpaperType = localStorage.getItem('wallpaperType') || 'default'
      const wallpaperColor = localStorage.getItem('wallpaperColor')
      if (wallpaperUrl && wallpaperType && (wallpaperType === 'preset' || wallpaperType === 'custom')) {
        document.body.style.backgroundImage = `url(${wallpaperUrl})`
        document.body.style.backgroundSize = 'cover'
        document.body.style.backgroundPosition = 'center'
        document.body.style.backgroundRepeat = 'no-repeat'
        document.body.classList.add('has-wallpaper')
      } else if (wallpaperColor && wallpaperType === 'color') {
        document.body.style.backgroundImage = ''
        document.body.style.backgroundColor = wallpaperColor
        document.body.classList.remove('has-wallpaper')
      } else {
        document.body.style.backgroundImage = ''
        document.body.style.backgroundColor = ''
        document.body.classList.remove('has-wallpaper')
      }
    },
    async loadUserThemeSettings() {
      const userStr = localStorage.getItem('userInfo')
      if (!userStr) return

      // 获取用户 ID
      try {
        const userInfo = JSON.parse(userStr)
        const userId = userInfo.userId || userInfo.id
        if (!userId) return

        // 从后端加载主题/背景设置并应用
        const data = await loadUserThemeFromBackend(this.$axios, userId)

        // 通知 SettingsPanel 内的 BackgroundSetting / ThemeSetting：
        // App.vue 已经从后端加载过，不要重复加载（避免冲突）
        if (data) {
          this.$bus && this.$bus.$emit('user-theme-loaded', data)
          // 用 localStorage 作为后备标记，防止 SettingsPanel 先于 $bus 事件监听注册完成
          localStorage.setItem('userThemeLoaded', '1')
        }
      } catch (e) {
        console.warn('加载用户主题设置失败:', e)
      }
    }
  }
}
</script>

<style>
/* 路由跳转过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
